module.exports = __webpack_public_path__ + "static/media/icon-equipe-orange.9f6e072f.svg";